export const usersColumns = [
  { field: 'firstName', headerName: 'First name', width: 130 },
  { field: 'lastName', headerName: 'Last name', width: 130 },
  {
    field: 'phoneNumber',
    headerName: 'Phone Number',
    width: 200,
  },
  { field: 'email', headerName: 'Email', width: 230 },
]
